import React, { useEffect } from 'react'
import PageLayout from 'components/layouts/PageLayout'
import SectionLayout from 'components/layouts/SectionLayout';
import SmallBanner from 'components/SmallBanner'
import Accordion from 'components/Accordion';
import { faqsContent } from './content/faqsContent';
import { faqsBannerContent } from './content/banner.js';

function FAQs() {
  
  useEffect(() => {
    // Change Tab Title
    document.title = "FAQs - Insurance Enterprise"
  }, [])

  return (
    <>

      <SmallBanner content={faqsBannerContent} />
      <PageLayout
        content={<SectionLayout content={<Accordion content={faqsContent} />} />}
      />

    </>
  )
}

export default FAQs